/* eslint-disable no-restricted-globals */
type PopupCenterProps = {
  url: string;
  target?: string;
  width: number;
  height: number;
};

export const popupCenter = ({
  url,
  target = '',
  width,
  height,
}: PopupCenterProps): Window | null => {
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

  const clientWidth = window.innerWidth || document.documentElement.clientWidth || screen.width;

  const clientHeight = window.innerHeight || document.documentElement.clientHeight || screen.height;

  const systemZoom = clientWidth / window.screen.availWidth;
  const left = (clientWidth - width) / 2 / systemZoom + dualScreenLeft;
  const top = (clientHeight - height) / 2 / systemZoom + dualScreenTop;
  const newWindow = window.open(
    url,
    target,
    `
    scrollbars=yes,
    width=${width},
    height=${height},
    top=${top},
    left=${left}
    `
  );
  if (window.hasOwnProperty('focus')) {
    newWindow?.focus();
  }

  var timer = setInterval(function () {
    if (newWindow?.closed) {
      window.parent.postMessage('payment-paypal-closed', window.parent.location.origin);
      clearInterval(timer);
    }
  }, 1000);

  return newWindow;
};
